import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import styled from 'styled-components';
import { media, theme } from 'styles';
import { Breadcrumbs, Container } from 'components/shared';
import routes from 'helpers/routes';
import ThankYouPageCharacters from 'images/thank-you-page-characters.png';

const { sp } = theme;

const Wrapper = styled.div`
  min-height: 600px;
  position: relative;
  overflow: hidden;

  &::before {
    position: absolute;
    transform: rotate(-15deg);
    background-image: url('${props => props.src}');
    background-repeat: no-repeat;
    content: '';

    width: 100%;
    top: 0;
    right: 0;
    height: 100%;
    background-size: 75%;
    background-position: center bottom 10%;

    ${media.laptop`
      top: 150px;
      right: 350px;
      height: 200%;
      background-size: 700px;
      background-position: top right;
    `}

    ${media.desktop`
      top: 150px;
      right: 350px;
      height: 200%;
      background-size: 700px;
      background-position: top right;
    `}
  }
`;

const Banner = styled.div`
  position: relative;
  padding: 60px 0 100px;
  max-width: 800px;

  ${media.tablet`
    padding: 100px 0;
  `};

  h1 {
    max-width: 600px;
    font-size: 40px;
    line-height: 48px;
    letter-spacing: -0.8px;
    margin-top: ${sp.xxl};
    margin-bottom: ${sp.xxl};
    font-weight: 700;

    ${media.tablet`
      margin-top: ${sp.l};
      font-size: 60px;
      line-height: 72px;
      letter-spacing: -1.1px;
    `};
  }
`;

const ThankYouImg = styled.img`
  max-width: 100%;
  margin-top: -100px;
  ${media.desktop`
    position: absolute;
    top: -70px;
    right: 0;
    margin: 0;
    max-width:800px;
  `};
`;

const ContentBody = styled.div`
  p {
    &:last-child {
      margin-top: 20px;
    }
  }
`;

const propTypes = {
  contactUs: PropTypes.bool.isRequired,
};

function ThankYou({ contactUs }) {
  const breadcrumbs = [
    {
      name: 'Home',
      link: '/',
    },
    {
      name: 'Thank You',
      link: '/thank-you',
    },
  ];

  const body = (
    <ContentBody>
      <h1>Success! You are now subscribed to Tap’d In!</h1>
      <p>
        You can look forward to receiving the latest scoop on industry insights
        as well as social and digital trends, sent weekly to your inbox!
      </p>
      <p>
        Want to browse our previous blog posts? Check out{' '}
        <Link to={routes.blog.index}>Click Here.</Link>
      </p>
    </ContentBody>
  );

  const contactUsBody = (
    <ContentBody>
      <h1>Thanks for reaching out!</h1>
      <p>Someone from our team will be in contact soon.</p>
      <p>
        Looking to Book a Call?{' '}
        <Link to={routes.bookMarketer.index}>Click Here.</Link>
      </p>
    </ContentBody>
  );

  return (
    <Wrapper>
      <Banner>
        <Container>
          <Breadcrumbs breadcrumbs={breadcrumbs} left />
          {contactUs ? contactUsBody : body}
        </Container>
      </Banner>
      <ThankYouImg src={ThankYouPageCharacters} />
    </Wrapper>
  );
}

ThankYou.propTypes = propTypes;

export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/shared/ThankYou/ThankYou.jsx